// extracted by css-extract-rspack-plugin
export default {"page__headerroom":"page__headerroom-SWbp8R","pageHeaderroom":"page__headerroom-SWbp8R"};